module.exports = __webpack_public_path__ + "static/media/Clock.10a3ea23.svg";